<template>
    <p class="totem-loader-msg">{{ message }}</p>
</template>

<script>
    import i18n from 'services/i18n'

    export default {
        name: 'totem-loader-msg',
        computed: {
            message () {
                return i18n.t('TotemLoader.message')
            }
        }
    }
</script>

<style lang="scss">
    .totem-loader-msg {
        font-family: Nunito-Regular, sans-serif;
        font-size: 2.2rem;
    }
</style>
